import { render, staticRenderFns } from "./EpsAttachmentCategoryForm.vue?vue&type=template&id=6f2021bd&"
import script from "./EpsAttachmentCategoryForm.vue?vue&type=script&lang=js&"
export * from "./EpsAttachmentCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports